import type React from 'react';

import upperFirst from 'lodash/upperFirst';

import { LocalizeDate, useI18n } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconVictory } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { LegacyHtml as Html } from 'src/app/shared/components/html';

type Props = {
	createdAt: string;
	description: string;
};

export const VictoryUpdate = (({ ref, createdAt, description }) => {
	const { translate } = useI18n();
	const isSunriseThemeEnabled = useIsSunriseTheme();
	const victoryHeading = upperFirst(translate('fe.pages.petition_show.status.victory'));

	return (
		<Box
			variant="bordered"
			sx={{
				borderColor: isSunriseThemeEnabled ? 'sunrise.semantic.stroke.weaker' : 'neutral-grey100',
				backgroundColor: isSunriseThemeEnabled ? 'sunrise.semantic.stroke.inverse.strong' : 'primary-white',
				overflow: 'hidden',
				borderWidth: [0, 1],
			}}
			p={16}
			ref={ref}
			data-qa="petition-update-victory"
		>
			<Text size="large" sx={{ textAlign: 'center' }}>
				<Icon
					icon={iconVictory}
					color={isSunriseThemeEnabled ? 'sunrise.semantic.fill.brand.strong' : 'primary-changeRed'}
					size="xxxl"
					my={16}
					mx="auto"
					sx={{ display: 'block' }}
				/>
				<Heading as="div" size="h2" mt={0} mb={16}>
					{victoryHeading}
				</Heading>
			</Text>
			<Text as="div">
				<LocalizeDate date={createdAt} type="date" format="medium" />
				{' — '}
			</Text>
			<Html html={description} breakWord />
		</Box>
	);
}) as React.FC<
	Props & {
		ref?: React.RefObject<HTMLDivElement>;
	}
>;
